import { Dialog } from "@/components/ui/Dialog";
import { Button } from "@/components/ui/Button";
import { MontageunterlagenPackView } from "@/projectOverview/MontageunterlagenDialog";

export function MyDayMontageunterlagenViewModal({
  open,
  onClose,
  orderId,
  orderLabel,
  onEdit,
}: {
  open: boolean;
  onClose: () => void;
  orderId: number;
  orderLabel: string;
  onEdit?: () => void;
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Montageunterlagen"
      description={orderLabel}
      size="2xl"
      fullScreenMobile
      zIndexClass="z-[220]"
      footer={
        <>
          {onEdit ? (
            <Button type="button" variant="secondary" onClick={onEdit} className="mr-auto">
              Bearbeiten
            </Button>
          ) : null}
          <Button type="button" variant="secondary" onClick={onClose}>
            Schließen
          </Button>
        </>
      }
      bodyClassName="max-h-[min(85vh,920px)] overflow-y-auto max-sm:max-h-none max-sm:flex-1"
    >
      {open ? <MontageunterlagenPackView orderId={orderId} /> : null}
    </Dialog>
  );
}
